import * as React from "react";
import { DefaultButton, PrimaryButton, TextField } from "@fluentui/react";
import { Panel } from "@fluentui/react";
import { useState, useContext, useEffect } from "react";
import { DatePicker, SpinButton, Stack } from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";
import { dbDate } from "../../Utilities/dbDate";
import NetGrossPicker from "../../Components/NetGrossPicker";

function AddTransactionInvoice(props) {
    const [user] = useContext(AuthContext);
    const [invoiceNumber, setInvoiceNumber] = useState("");
    const [net, setNet] = useState(0);
    const [vat, setVat] = useState(0);
    const [gross, setGross] = useState(0);
    const [deadline, setDeadline] = useState(null);

    const _submit = (e) => {
        e.preventDefault();
        const data = {
            invoice_number: invoiceNumber,
            deadline: dbDate(deadline),
            net_value: net,
            vat: vat,
            gross_value: gross,
            type: props.add.type,
            addons: props.add.items.map((item) => item.id),
        };
        fetch(`/api/transaction/${props.add.items[0].transaction_id}/invoice`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Authorization": "Bearer " + user.token,
            },
        }).then(res => res.json())
            .then(json => {
                props.onSuccess(json);
                props.dismissPanel();
            })
            .catch(err => {
                console.log(err);
            });
    };

    useEffect(() => {
        if (props.add) {
            setNet(props.add.items.reduce((prev, curr) => prev + parseFloat(curr.total_net_price), 0));
            setGross(props.add.items.reduce((prev, curr) => prev + parseFloat(curr.total_gross_price), 0));
            setVat(props.add.items.reduce((prev, curr) => prev > parseInt(curr.vat) ? prev : parseInt(curr.vat), 0));
            setInvoiceNumber("");
            setDeadline(props.add.items.reduce((prev, curr) => {
                let prevDate = prev;
                if (!prevDate instanceof Date) {
                    prevDate = new Date(prev.deadline);
                }
                const currDate = new Date(curr.deadline);
                if (currDate > prevDate) {
                    return currDate;
                }
                return prevDate;
            }, new Date()));
        }
    }, [props.add]);

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign="space-between">
        <PrimaryButton type="submit" form="AddTransactionInvoice">Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);

    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Fakturę"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id="AddTransactionInvoice">
                <TextField required autoFocus label="Numer Faktury" value={invoiceNumber}
                           onChange={(e) => setInvoiceNumber(e.target.value || "")} />
                <NetGrossPicker net={net} setNet={setNet} gross={gross} setGross={setGross} vat={vat} setVat={setVat} />
                <DatePicker
                    label="Termin Płatności"
                    isRequired={true}
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={deadline}
                    onSelectDate={(e) => setDeadline(e || "")}
                />
            </form>
        </Panel>
    );
}

export default AddTransactionInvoice;